import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import { ACCESS_TOKEN } from "@/store/mutation-types";
var FILE_TYPE_ALL = "all";
var FILE_TYPE_IMG = "image";
var FILE_TYPE_TXT = "file";

var uidGenerator = function uidGenerator() {
  return '-' + parseInt(Math.random() * 10000 + 1, 10);
};

var getFileName = function getFileName(path) {
  if (path.lastIndexOf("\\") >= 0) {
    var reg = new RegExp("\\\\", "g");
    path = path.replace(reg, "/");
  }

  return path.substring(path.lastIndexOf("/") + 1);
};

export default {
  name: 'JUpload',
  data: function data() {
    return {
      uploadAction: window._CONFIG['domianURL'] + "/sys/common/upload",
      urlDownload: window._CONFIG['domianURL'] + "/sys/common/download/",
      headers: {},
      fileList: []
    };
  },
  props: {
    text: {
      type: String,
      required: false,
      default: "点击上传"
    },
    fileType: {
      type: String,
      required: false,
      default: FILE_TYPE_ALL
    },

    /*这个属性用于控制文件上传的业务路径*/
    bizPath: {
      type: String,
      required: false,
      default: "temp"
    },
    value: {
      type: String,
      required: false
    },
    //此属性被废弃了
    triggerChange: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    value: function value(val) {
      this.initFileList(val);
    }
  },
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      "X-Access-Token": token
    };
  },
  methods: {
    initFileList: function initFileList(paths) {
      if (!paths || paths.length == 0) {
        return [];
      }

      var fileList = [];
      var arr = paths.split(",");

      for (var a = 0; a < arr.length; a++) {
        fileList.push({
          uid: uidGenerator(),
          name: getFileName(arr[a]),
          status: 'done',
          url: this.urlDownload + arr[a],
          response: {
            status: "history",
            message: arr[a]
          }
        });
      }

      this.fileList = fileList;
    },
    handlePathChange: function handlePathChange() {
      var uploadFiles = this.fileList;
      var path = '';

      if (!uploadFiles || uploadFiles.length == 0) {
        path = '';
      }

      var arr = [];

      for (var a = 0; a < uploadFiles.length; a++) {
        arr.push(uploadFiles[a].response.message);
      }

      if (arr.length > 0) {
        path = arr.join(",");
      }

      this.$emit('change', path);
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType === FILE_TYPE_IMG) {
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return false;
        }
      } else if (fileType === FILE_TYPE_TXT) {
        if (fileType.indexOf('image') >= 0) {
          this.$message.warning('请上传文件');
          return false;
        }
      } //TODO 扩展功能验证文件大小


      return true;
    },
    handleChange: function handleChange(info) {
      var _this = this;

      console.log("--文件列表改变--");
      var fileList = info.fileList;

      if (info.file.status === 'done') {
        if (info.file.response.success) {
          fileList = fileList.map(function (file) {
            if (file.response) {
              file.url = _this.urlDownload + file.response.message;
            }

            return file;
          });
        }

        this.$message.success("".concat(info.file.name, " \u4E0A\u4F20\u6210\u529F!"));
      } else if (info.file.status === 'error') {
        this.$message.error("".concat(info.file.name, " \u4E0A\u4F20\u5931\u8D25."));
      } else if (info.file.status === 'removed') {
        this.handleDelete(info.file);
      }

      this.fileList = fileList;

      if (info.file.status === 'done' || info.file.status === 'removed') {
        this.handlePathChange();
      }
    },
    handleDelete: function handleDelete(file) {
      //如有需要新增 删除逻辑
      console.log(file);
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
};